<template>


  <div class="bg-white overflow-hidden shadow-sm pt-3 sm:rounded-xs border my-3">
    <div class="mx-3">
     <h6 >Last 7 day attendance history</h6>
     <p class="text-xs">8-16 Aug 2024</p>
  </div>
    <!-- <DxDataGrid
      id="gridContainer"
      :data-source="dataSource"
      :show-borders="true"
      :customize-columns="customizeColumns"
    >
      <DxColumn dataField="date" caption="Date" />
      <DxColumn dataField="inTime" caption="In-time" />
      <DxColumn dataField="outTime" caption="Out-time" />
      <DxColumn dataField="status" caption="Status" />
    </DxDataGrid> -->

    

    <div class="relative overflow-x-auto m-3 ">
    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
      <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
        <tr>
          <th scope="col" class="px-2 py-2 rounded-s-lg">Date</th>
          <th scope="col" class="px-3 py-2 text-center">In-time</th>
          <th scope="col" class="px-3 py-2 text-center">Out-time</th>
          <th scope="col" class="pr-2 pl-4 py-2 rounded-e-lg text-right">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr  v-for="(record, index) in attendanceRecords" 
          :key="index" 
          :class="index % 2 === 0 ? 'bg-white dark:bg-gray-800 text-xs' : 'bg-gray-50 dark:bg-gray-900 text-xs'">
          <th scope="row" class="py-2 px-2  font-medium text-gray-900 whitespace-nowrap dark:text-white">
            {{ record.date }}
          </th>
          <td class="px-3 py-2 text-center">{{ record.inTime }}</td>
          <td class="px-3 py-2 text-center">{{ record.outTime }}</td>
          <td class="px-3 py-2 text-right">{{ record.status }}</td>
        </tr>
      </tbody>
     
    </table>
  </div>

     <!-- Leave type, total, credit and balance end -->
  
  </div>

</template>

<script>
import JetButton from '@/Jetstream/Button.vue'
import {
  DxDataGrid, DxColumn
} from 'devextreme-vue/data-grid';

export default {
  components: {
    JetButton,
    DxDataGrid,
    DxColumn,

  },
  props: {
   
  },

  data() {

    return {
      attendanceRecords: [
        {  date: '2024-08-05', inTime: '09:00 AM', outTime: '05:00 PM', status: 'Present' },
        {  date: '2024-08-05', inTime: '09:30 AM', outTime: '05:30 PM', status: 'Present' },
        {  date: '2024-08-05', inTime: '10:00 AM', outTime: '06:00 PM', status: 'Late' },
        {  date: '2024-08-05', inTime: '08:45 AM', outTime: '04:45 PM', status: 'Present' },
        {  date: '2024-08-05', inTime: '09:15 AM', outTime: '05:15 PM', status: 'Present' },
        {  date: '2024-08-05', inTime: '08:45 AM', outTime: '04:45 PM', status: 'Present' },
        {  date: '2024-08-05', inTime: '09:15 AM', outTime: '05:15 PM', status: 'Present' },
      ], 

    };
  },

  methods: {
    // customizeColumns(columns) {
    //   columns.forEach((column) => {
    //     if (column.dataField === 'status') {
    //       column.alignment = 'center';
    //     }
    //   });
    // },
  },

  computed: {
   

  }
}

</script>

<style>
#gridContainer {
  margin: 20px;
}
</style>